webpackJsonp([35252511437423],{

/***/ 819:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---tutorials-examples-microwave-parallel-a0e39f21c11f6a62c5ab.js